export default {
  MODALVIDEO: "MODALVIDEO"
};



// WEBPACK FOOTER //
// ./scripts/lib/helpers/CustomEventType.js